// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2_pQJ","inputWrap":"CustomTip_inputWrap__3OOzH"};